import { Lock, LockReasonTitle, UserDetails } from '../types';
import IconLock from '../../icons/lock';
import IconUnlock from '../../icons/unlock';
import formatDate from '../../../helpers/format-date';

import cn from '../styles.module.css';

const formatLocksList = (list: Lock[], employees?: UserDetails[]): Lock[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let currentEmployeeName = '-';

    if (result.createdByEmployeeId) {
      const currentEmployee = employees?.find(
        (employee) => employee.id === result.createdByEmployeeId,
      );

      if (currentEmployee) {
        currentEmployeeName = `${currentEmployee?.profile?.firstName} ${currentEmployee?.profile?.lastName}`;
      }
    }

    const render: Record<string, React.JSX.Element> = {};
    render.locked = (
      <div className={`${cn.lockedRow} ${!result.locked ? cn.unlocked : ''}`}>
        {result.locked ? <IconLock width={16} height={16} /> : <IconUnlock />}
        {result.locked ? 'Yes' : 'No'}
      </div>
    );
    render.reason = (
      <div className={!result.locked ? cn.unlocked : ''}>
        {/* @ts-ignore */}
        {LockReasonTitle[result.reason]}
      </div>
    );
    render.createdByEmployeeId = (
      <div className={!result.locked ? cn.unlocked : ''}>
        {currentEmployeeName}
      </div>
    );
    render.createdAt = (
      <div className={!result.locked ? cn.unlocked : ''}>
        {result.createdAt ? formatDate(result.createdAt, true) : '-'}
      </div>
    );
    render.expiresAt = (
      <div className={!result.locked ? cn.unlocked : ''}>
        {result.expiresAt ? formatDate(result.expiresAt, true) : '-'}
      </div>
    );
    render.userId = (
      <div className={!result.locked ? cn.unlocked : ''}>{result.userId}</div>
    );
    render.type = (
      <div className={!result.locked ? cn.unlocked : ''}>{result.type}</div>
    );
    render.createdByComment = (
      <div className={!result.locked ? cn.unlocked : ''}>
        {result.createdByComment}
      </div>
    );

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatLocksList;
